$(() => {
  // ユーザー新規登録ボタン多重クリック防止
  $('#register_submit').on('click', function () {
    $(this).css('pointer-events', 'none')
    $(this).addClass('disabled')
  })
})